import { Injectable, inject } from '@angular/core';

import { ParsedUrl, ProductService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

import { DefaultLanguageSwitcherUrlsProvider } from './default-language-switcher-urls-provider';
import { LanguageSwitcherUrlsProvider, PRODUCT_LANGUAGE_SWITCHER_URLS_PROVIDER } from './language-switcher-urls-provider';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class SingleDomainLanguageSwitcherUrlsProvider implements LanguageSwitcherUrlsProvider {
    private readonly defaultLanguageSwitcher = inject(DefaultLanguageSwitcherUrlsProvider);
    private readonly productService = inject(ProductService);

    getUrls(url: ParsedUrl, languages: string[]): Observable<Map<string, string>> {
        const currentProvider = this.getCurrentLanguageSwitcherProvider();

        return currentProvider.getUrls(url, languages);
    }

    private getCurrentLanguageSwitcherProvider(): LanguageSwitcherUrlsProvider {
        return this.productService.current.injector.get<LanguageSwitcherUrlsProvider>(
            PRODUCT_LANGUAGE_SWITCHER_URLS_PROVIDER,
            this.defaultLanguageSwitcher,
        );
    }
}
